function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.40015 12.5996H16.8001",
  stroke: "white",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.4001 7.6998C15.4001 4.99361 17.594 2.7998 20.3001 2.7998C23.0063 2.7998 25.2001 4.99361 25.2001 7.6998C25.2001 10.406 23.0063 12.5998 20.3001 12.5998C19.1414 12.5998 18.0765 12.1976 17.2376 11.5251",
  stroke: "white",
  strokeWidth: 2
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.6 18.1997V25.1997M12.6 18.1997L8.54355 13.1382L4.19995 7.69971H21L16.5846 13.1382L12.6 18.1997ZM12.6 25.1997H9.09995M12.6 25.1997H16.1",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M2.80005 2.7998H7.70005L12.6 12.5998",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgCocktail = function SvgCocktail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCocktail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cocktail.76365d49.svg";
export { ForwardRef as ReactComponent };